import { FolderColors } from 'stories/utils/theme'
import { Subject } from './Subject'
import { User } from './User'

export enum FolderTypes {
    StudyLater = 'STUDY_LATER_FOLDER',
    LikedKnow = 'LIKED_KNOWS_FOLDER',
    Default = 'FOLDER',
}

export interface KnowFolder {
    color: FolderColors
    createdOn: string
    description: string | null
    isDeletable: boolean
    isEditable: boolean
    isPublic: boolean
    knowSnapCount: number
    knowThumbnails: string[] | null
    knowsCount: number
    name: string
    questionsCount: number
    saveCount: number
    subject: Subject | null
    type: FolderTypes
    user: User
    userUuid: string
    uuid: string
}

export interface FolderRequest {
    color: FolderColors
    description: string
    isPublic: boolean
    name: string
    knowUuids: string[]
    questionUuids: string[]
    subjectId: number | null
    topicUuid: string | null
}

export interface FolderUpdateRequest {
    color?: FolderColors
    description?: string
    isPublic?: boolean
    name?: string
}
